module.exports = __webpack_public_path__ + "img/8.52b5a093.svg";